import { gql } from "@apollo/client";
import { DUES_RATE_FRAGMENT } from "@/fragments";

export const GET_DUES_RATES_QUERY = gql`
  query GetDuesRates($filters: BackofficeDuesDuesRatesInput!) {
    totalDuesRates: duesRates(filters: { kind: "national" }) {
      totalCount
    }
    duesRates(filters: $filters) {
      nodes {
        ...DuesRateFragment
      }
    }
  }
  ${DUES_RATE_FRAGMENT}
`;

export const GET_MANAGE_DUES_RATES_QUERY = gql`
  query GetManageDuesRates($filters: QueriesBackofficeDuesManageDuesRatesQueryInput!) {
    manageDuesRates(filters: $filters) {
      canEdit
      canFinalize
    }
  }
`;

export const UPDATE_DUES_RATES_MUTATION = gql`
  mutation UpdateDuesRates($input: BackofficeDuesBulkEditDuesRatesInput!) {
    duesBulkEditRates(input: $input) {
      success
      message
    }
  }
`;

export const DUES_FINALIZE_RATES_MUTATION = gql`
  mutation DuesFinalizeRates($input: MutationsBackofficeDuesFinalizeDuesRatesInput!) {
    duesFinalizeRates(input: $input) {
      success
      message
      code
      errors
    }
  }
`;
